import { Component, Input, OnChanges } from '@angular/core';
import { filter, tap } from 'rxjs/operators';

import { PrivateSegmentsEditDialogService } from '@main-client/src/app/private-segments-selections/private-segments-edit-dialog/private-segments-edit-dialog.service';

import {
  Account,
  AccountGroupMembership,
  AccountSegmentSelection,
} from '@libs/src/models/account.model';
import { GroupHiddenCustomSegment } from '@libs/src/models/group.model';
import {
  getHiddenSegmentsVisibleToUser,
  getSegmentationSelection,
} from '@libs/src/segment-selections/segment-selections.helper';
import { getMembership } from '@main-client/src/app/account/account.helpers';

import isEmpty from 'lodash-es/isEmpty';
import reduce from 'lodash-es/reduce';

@Component({
  selector: 'app-private-segments-selections',
  templateUrl: './private-segments-selections.component.html',
})
export class PrivateSegmentsSelectionsComponent implements OnChanges {
  @Input() account: Account;
  @Input() user: Account;
  @Input() membership: AccountGroupMembership;
  segmentsToDisplay: GroupHiddenCustomSegment[];
  segmentsWithSelection: { [key: string]: AccountSegmentSelection } = {};

  constructor(
    private readonly privateSegmentsEditDialogService: PrivateSegmentsEditDialogService,
  ) {}

  ngOnChanges() {
    this.segmentsToDisplay = getHiddenSegmentsVisibleToUser(
      this.membership.document,
      this.user,
      this.account,
    );
    this.segmentsWithSelection = this.generateSegmentsToSelectionsMap(
      this.segmentsToDisplay,
      this.membership,
    );
  }

  generateSegmentsToSelectionsMap(
    segments: GroupHiddenCustomSegment[],
    membership: AccountGroupMembership,
  ) {
    return reduce(
      segments,
      (accumulator, customSegment: GroupHiddenCustomSegment) => {
        return {
          ...accumulator,
          [customSegment._id]: getSegmentationSelection(
            membership.hidden_segment_selections,
            customSegment,
          ),
        };
      },
      {},
    );
  }

  openPrivateSegmentsEditDialog(
    user: Account,
    account: Account,
    membership: AccountGroupMembership,
  ) {
    this.privateSegmentsEditDialogService
      .openDialog({
        account,
        membership,
        user,
      })
      .afterClosed()
      .pipe(
        filter((updatedAccount: Account) => !isEmpty(updatedAccount)),
        tap((updatedAccount: Account) => {
          this.account = updatedAccount;
          const group = this.membership.document;
          this.membership = getMembership(updatedAccount.groups, group?._id);
          this.segmentsWithSelection = this.generateSegmentsToSelectionsMap(
            this.segmentsToDisplay,
            this.membership,
          );
        }),
      )
      .subscribe();
  }
}
